var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"h-100"},[_c('v-row',{staticClass:"d-flex justify-center my-10",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"10","md":"9","lg":"8"}},[_c('CardTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }